import React from "react";
import Modal from "react-bootstrap/Modal";
import { wpPath } from "../../config/key";
import { Button } from "react-bootstrap";


const DiaryNotice = ({ show, setShow, type,handleDelete,reportType, giaNumber }) => {
 
  return (
    <>
      <Modal
        className="diary-notice-modal"
        show={show}
        onHide={() => setShow(false)}
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <>
            {(type === "shape_not_supported" || type === "color_not_supported" || type === "preventreport") && (
              <p>
                Our automated report generator currently does not support this  {type === "shape_not_supported"?"shape":"color"}.  Please  { " "}
                <a
                  href={`${wpPath}/special-request-for-diary-report?ReportType=${reportType==='rarity'? "Rarity":"Diary"}&GiaNumber=${giaNumber}&member=${localStorage.getItem("fcrf@token")?"true":"false"}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  click here
                </a>{" "}
               to request a custom made report.
              </p>
            )}
             {(type === "pro_trade_color_not_supported"  || type === "pro_trade_shape_not_supported") && (
              <p className="text-center">
              This diamond’s {type ==="pro_trade_color_not_supported"?"color":"shape"} isn’t supported in your current plan. {" "}<br/>

                <a
                  href={`${wpPath}/membership-plans/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
              Upgrade to request a custom-made report
                </a>{" "}
               
              </p>
            )}
            {type === "unauthorized" && (
              <p>
                 Report not found due to some issues, please search again!
              </p>
            )}
             {type === "natural" && (
              <p>
                {reportType==="diary"&&"The Diary Report is only available for fancy color diamonds with a full GIA report."}
                
               
              </p>
            )}

           {type === "notnatural" && (
              <p>
                {
                  reportType==="diary"?"The Diary Report is only available for natural fancy color diamonds.":"The Rarity Report is only available for natural fancy color diamonds."
                }
                 
                
              </p>
            )}
        
             {(type === "notsupported" &&reportType==="rarity") &&<p>The Rarity Report is only available for fancy color diamonds with a full GIA report.</p>}
             {(type === "notsupported" &&reportType==="diary") &&<p>The Diary Report is only available for fancy color diamonds with a full GIA report.</p>}
            {(type === "notfound" ) && <p>{reportType==="diary"?"The Diary Report is only available for fancy color diamonds with a full GIA report.":"The Rarity Report only supports fancy color diamonds"}</p>}
            {type === "cartlessthan" && (
              <p>
                {reportType==="diary"?"The Diary Report only supports diamonds that are 0.18 carats and above.":"The Rarity Report only supports diamonds that are 0.18 carats and above."}
              </p>
            )}

{type === "cartgraterthan" && (
              <p>
                {reportType==="diary"?"The Diary Report only supports diamonds that are 0.18 carats and above.":"The Rarity Report only supports diamonds that are 0.18 carats and above."}
              </p>
            )}

{type === "Search for a GIA number that does not exist in GIA" && <p>This report number doesn't exist in the GIA database. Please verify the number and try again</p>}

{type === "Report Id Not Found" && <p>This Report Id doesn't exist in the database. Please verify the Id and try again</p>}

            
           
            {type === "delete" && (
              <div className="diary-delete-modal">
              <p>
                 Are you sure you want to delete?
              </p>
              <div className="delete-modal-btn"><Button className="no-outline-btn" onClick={()=>handleDelete()}>Confirm</Button>
              <Button className="outline-btn" onClick={()=>setShow(false)}>Cancel</Button></div>
              </div>
            )}
            {type === "hideRarity" && (
              <p>
               The rarity report only supports diamonds with a clarity grade.
              </p>
            )}
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DiaryNotice;
